export default __webpack_public_path__ + "static/media/founders-heel.e0bb480f.mov";